/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Services_Event_CtaInputs */

const ja_playdata_home_services_event_cta = /** @type {(inputs: Playdata_Home_Services_Event_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツイベントレポートの詳細`)
};

const en_playdata_home_services_event_cta = /** @type {(inputs: Playdata_Home_Services_Event_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Event Reports`)
};

/**
* | output |
* | --- |
* | "About Event Reports" |
*
* @param {Playdata_Home_Services_Event_CtaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_services_event_cta = /** @type {((inputs?: Playdata_Home_Services_Event_CtaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Services_Event_CtaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_services_event_cta(inputs)
	return en_playdata_home_services_event_cta(inputs)
});